module.exports = __webpack_public_path__ + "img/charity_thumbnail-400x300.bedb7ab4.jpg";